import {defineStore} from "pinia";
import {ref} from "vue";
import {getCustomerAccountList, getCustomerList, getCustomerStoreList} from "@/apis/customer-data";

// 客户信息表 列表
const customer = ref([]);
// 客户信息表 Map key:customerId
const customerIdMap = ref(new Map());

// 门店信息表 列表
const customerStore = ref([]);
// 门店信息表 Map key:storeId
const customerStoreIdMap = ref(new Map());

// 客户账号 列表
const customerAccount = ref([]);
// 客户账号 Map key:编码
const customerAccountCodeMap = ref(new Map());

export const useCustomerStore = defineStore('customer', () => {
    const initCustomerData = () => {
        getCustomerList().then((res) => {
            customer.value = res.data;
            handleCustomerIdMap()
        });
    };
    return  {
        // 初始化所有数据
        initCustomerData,
        customer,
        customerIdMap
    }
})
export const useCustomerStoreInfoStore = defineStore('customerStore', () => {
    const initCustomerStoreData = () => {
        getCustomerStoreList().then((res) => {
            customerStore.value = res.data;
            handleCustomerStoreIdMap()
        });
    };
    return  {
        // 初始化所有数据
        initCustomerStoreData,
        customerStore,
        customerStoreIdMap
    }
})

export const useCustomerAccountStore = defineStore('customerAccount', () => {
    const initCustomerAccountData = () => {
        getCustomerAccountList().then((res) => {
            handleCustomerAccountCodeMap()
        });
    };
    return  {
        // 初始化所有数据
        initCustomerAccountData,
        customerAccount,
        customerAccountCodeMap
    }
})

function handleCustomerIdMap() {
    customerIdMap.value = new Map(customer.value?.map(item => [item.id, item]));
}
function handleCustomerStoreIdMap() {
    customerStoreIdMap.value = new Map(customerStore.value?.map(item => [item.id, item]));
}
function handleCustomerAccountCodeMap() {
    customerAccountCodeMap.value = new Map(customerAccount.value?.map(item => [item.code, item]));
}
